import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { CONTENT } from "@/data/content";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem("mn-theme") || "dark"); // Night Cockpit default
  const [lang, setLang] = useState(() => localStorage.getItem("mn-lang") || "en");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("mn-theme", theme);
  }, [theme]);

  useEffect(() => { localStorage.setItem("mn-lang", lang); }, [lang]);

  const toggleTheme = useCallback(() => setTheme((t) => (t === "dark" ? "light" : "dark")), []);
  const toggleLang = useCallback(() => setLang((l) => (l === "en" ? "es" : "en")), []);

  const t = CONTENT[lang];

  const value = useMemo(
    () => ({ theme, lang, toggleTheme, toggleLang, setLang, t }),
    [theme, lang, toggleTheme, toggleLang, t]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
};
